module.exports = __webpack_public_path__ + "static/media/leftParticles.97177181.svg";